import React, { createContext } from 'react';
export const RemContext = createContext({
    scalable: false,
    factor: 414,
});
function RemProvider({ children, scalable = false, factor = 414, }) {
    return (React.createElement(RemContext.Provider, { value: { scalable, factor } }, children));
}
export default RemProvider;
